import { SpyneApp, SpyneTrait } from "spyne";
import { PageCardExpandedView } from "components/cards/page-card-expanded-view";
import { either, isEmpty, isNil } from "ramda";

export class CardTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "card$";
    super(context, traitPrefix);
  }

  static card$MinimizeAnimation(disableAnim = false) {
    const animDuration = disableAnim ? "0" : ".35s";
    const animVal = disableAnim
      ? "none"
      : `${animDuration} ease-in-out cardMaxAnimReverse`;
    this.card$SetRootVal("--expand-anim-reverse", animVal);
    this.card$SetRootVal("--card-anim-reverse-time", animDuration);

    this.card$ScrollCardIntoView({ block: "start" });

    this.card$SetRootRects();

    this.card$SetImgRootRects(false);

    if (disableAnim === false) {
      this.card$ScrollLock(false);
    }

    const cardMainContainer = this.props.el$(".card-container");
    cardMainContainer.addClass("minimize");
    cardMainContainer.removeClass("expanded");
  }

  static card$ToggleHideCard(cardId) {
    return either(isNil, isEmpty)(cardId) === false;
  }

  static card$MinimizeComplete(disableAnim = false) {
    const cardMainContainer = this.props.el$(".card-container");
    const cardMain = this.props.el$(".card-material");
    const cardExpandedContentHolder = this.props.el$(
      ".expanded-content-holder",
    );
    cardMain.inline = "";
    cardMainContainer.removeClass("minimize");
    cardExpandedContentHolder.removeClass("reveal");
  }

  static card$ExpandAnimation(isDeepLink = false) {
    const animDuration = isDeepLink ? "0" : ".35s";
    const animVal = isDeepLink
      ? "none"
      : `${animDuration} ease-in-out cardMaxAnim`;
    this.card$SetRootVal("--expand-anim", animVal);
    this.card$SetRootVal("--card-anim-time", animDuration);

    this.card$ScrollLock();

    this.card$SetRootRects();

    this.card$SetImgRootRects();

    if (isDeepLink === true) {
      const cardScrollContainer = this.props.el$(".card-scroll");

      const updateMargin = () => {
        SpyneApp.pluginsFn.updateScrollMarginAdjust(cardScrollContainer.el);
      };

      const updater = () => {
        requestAnimationFrame(updateMargin);
        this.card$RevealExpandedContent();
      };

      requestAnimationFrame(updater);
    }

    this.props.el$.removeClass("hide-card");
    this.props.el$.removeClass("hide");
    this.props.el$(".card-container").addClass("expanded");
  }

  static card$RevealExpandedContent(bool = true) {
    this.appendView(
      new PageCardExpandedView({ data: this.props.data }),
      ".expanded-content-holder",
    );
    this.props.el$(".expanded-content-holder").toggleClass("reveal", bool);
  }

  static card$ExpandAnimationComplete() {
    const cardScrollContainer = this.props.el$(".card-scroll");
    this.card$RevealExpandedContent();
    SpyneApp.pluginsFn.updateScrollMarginAdjust(cardScrollContainer.el);
  }

  static card$ScrollLock(bool = true) {
    const el = this.props.el$(".card-scroll").el;
    const fn = bool
      ? SpyneApp.pluginsFn.enableScrollLock
      : SpyneApp.pluginsFn.disableScrollLock;

    const addScrollBar = window.innerWidth > document.body.offsetWidth;

    //console.log('scroll lock logic going ', document.body.offsetWidth, window.innerWidth, {addScrollBar, bool, fn, el});

    fn(el, addScrollBar);
  }

  static card$ScrollCardIntoView() {
    SpyneApp.pluginsFn.scrollIntoView(this.props.el);
  }

  static card$UnhideCard() {
    const removeHiddenClass = () => {};

    requestAnimationFrame(removeHiddenClass);
    this.props.el$.removeClass("hide-card");
  }

  static card$checkForDeeplink(routeData, isDeepLink) {
    const expandCard = (page, card) => {
      const { pageId, cardId } = this.props.data;
      return page === pageId && card === cardId && isDeepLink === true;
    };
    const { pageId, cardId } = routeData;
    return expandCard(pageId, cardId);
  }

  static card$GetExpandedRect() {
    return document
      .querySelector(".card-expanded-holder")
      .getBoundingClientRect();
  }

  static card$GetMinRect() {
    const { top, left, width, height } = this.props.el.getBoundingClientRect();
    return { top, left, width, height };
  }

  static card$GetRatioRect() {
    let expandedContainerBBox = CardTraits.card$GetExpandedRect();
    const cardMainContainer = this.props.el$(".card-container");
    const thumbBox = cardMainContainer.el.getBoundingClientRect();
    let { top, left } = thumbBox;
    const { width, height } = this.card$MatchContainerWidthHeight(
      expandedContainerBBox,
      thumbBox,
    );
    return { top, left, width, height };
  }

  static card$SetRootVal(key, val) {
    document.documentElement.style.setProperty(key, val);
  }

  static card$GetRootVal(rootKey) {
    return getComputedStyle(document.documentElement).getPropertyValue(rootKey);
  }

  static card$SetRootRects() {
    const rectArr = ["top", "left", "width", "height"];

    const types = ["min", "max"];
    const typeMethodsHash = {
      min: this.card$GetMinRect,
      ratio: this.card$GetRatioRect,
      max: this.card$GetExpandedRect,
    };

    const setRectRootProps = (type) => {
      const rectFn = typeMethodsHash[type];
      const rect = rectFn();
      const forEachRectProp = (rectProp) => {
        const rootKey = `--app-card-${type}-${rectProp}`;

        let rootVal = `${rect[rectProp]}px`;
        document.documentElement.style.setProperty(rootKey, rootVal);
      };
      rectArr.forEach(forEachRectProp);
    };
    types.forEach(setRectRootProps);
  }

  static card$SetImgRootRects(isMaxAnim = true) {
    const getMinImgHeight = () => {
      const unExpandedImg = document.querySelectorAll(
        "li.page-card.hide .card-image",
      )[0];

      if (unExpandedImg) {
        return unExpandedImg.offsetHeight;
      }

      const initCardSizeHeight =
        this.props.el$(".card-initial-size").el.offsetHeight;
      const initSizeImgPct = 0.4462809917355372;

      if (initCardSizeHeight <= 10) {
        return parseInt(this.card$GetRootVal("--app-card-img-min-height"));
      }

      return initCardSizeHeight * initSizeImgPct;
    };

    const headerImgSel = "div.page-header figure.bg-image";

    const maxImgEl = isMaxAnim
      ? document.querySelector(headerImgSel)
      : this.props.el$(".card-image").el;
    const maxHeight = maxImgEl.offsetHeight;
    const minHeight = isMaxAnim
      ? this.props.el$(".card-image").el.offsetHeight
      : getMinImgHeight();

    document.documentElement.style.setProperty(
      "--app-card-img-max-height",
      `${maxHeight}px`,
    );
    document.documentElement.style.setProperty(
      "--app-card-img-min-height",
      `${minHeight}px`,
    );
  }

  static card$GetImgHeaderPct() {
    const imgSel = "div.page-header div.bg-image";
    const imgEl = document.querySelector(imgSel);
    const imgHeight = imgEl.offsetHeight * 1.025;

    return imgHeight;
  }

  static card$MatchContainerWidthHeight(
    containerBox,
    thumbBox,
    winWidth = window.innerWidth,
    winHeight = window.innerHeight,
  ) {
    const getWidthHeight = (bbox) => [bbox.width, bbox.height];
    const maxHeight = winHeight - 52;
    let [cW, cH] = getWidthHeight(containerBox);

    cH = Math.min(maxHeight, cH);
    const [tW, tH] = getWidthHeight(thumbBox);
    const ratio = Math.min(cW / tW, cH / tH);
    const height = cH / ratio;
    const width = cW / ratio;
    //console.log('boxes are ',{height, width, cW, cH, tW, tH,containerBox, thumbBox});
    return { width, height };
  }
}
